import { Link } from "react-router-dom";
import { brand, readingTips } from "@/mocks/site";

const categoryLinks = ["文娱现场", "网络热点", "消费维权", "公益舆情"];

export default function SiteFooter() {
  return (
    <footer className="mt-16 w-full bg-primary-950 text-background-200">
      <div className="mx-auto max-w-[1440px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-plant-line text-xl" aria-hidden="true" />
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-lg font-bold text-background-50">{brand.name}</span>
                <span className="mt-1 text-[10px] tracking-[0.28em] text-background-400">{brand.suffix}</span>
              </span>
            </div>
            <p className="mt-4 text-xs leading-relaxed text-background-300">{brand.intro}</p>
            <p className="mt-4 flex items-center gap-2 text-xs text-accent-300">
              <i className="ri-mail-line text-sm" aria-hidden="true" />
              {brand.email}
            </p>
          </div>

          <nav aria-label="页脚站内导航">
            <h2 className="font-heading text-sm font-semibold text-background-50">站内导航</h2>
            <ul className="mt-4 flex flex-col gap-2.5">
              <li>
                <Link to="/" className="text-xs text-background-300 transition-colors hover:text-accent-300">
                  首页 · 风向速览
                </Link>
              </li>
              <li>
                <Link to="/cases" className="text-xs text-background-300 transition-colors hover:text-accent-300">
                  案例库 · 全部档案
                </Link>
              </li>
              <li>
                <Link to="/guide" className="text-xs text-background-300 transition-colors hover:text-accent-300">
                  观察指南 · 四步核验法
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-xs text-background-300 transition-colors hover:text-accent-300">
                  关于我们 · 内容原则
                </Link>
              </li>
            </ul>
          </nav>

          <nav aria-label="页脚分类导航">
            <h2 className="font-heading text-sm font-semibold text-background-50">内容分类</h2>
            <ul className="mt-4 flex flex-col gap-2.5">
              {categoryLinks.map((category) => (
                <li key={category}>
                  <Link
                    to={`/cases?category=${encodeURIComponent(category)}`}
                    className="text-xs text-background-300 transition-colors hover:text-accent-300"
                  >
                    {category}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h2 className="font-heading text-sm font-semibold text-background-50">阅读提示</h2>
            <ul className="mt-4 flex flex-col gap-2.5 text-xs leading-relaxed text-background-300">
              {readingTips.map((tip) => (
                <li key={tip} className="flex gap-2">
                  <i className="ri-checkbox-blank-circle-line mt-0.5 text-[10px] text-accent-400" aria-hidden="true" />
                  <span>{tip}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-primary-800 pt-6 md:flex-row md:items-center md:justify-between">
          <p className="text-[11px] text-background-400">
            © {new Date().getFullYear()} {brand.copyright} · {brand.established}
          </p>
          <p className="text-[11px] leading-relaxed text-background-400">
            站内案例均经过匿名化处理，仅用于呈现信息流转过程，不构成对任何主体的评价或认定。
          </p>
        </div>
      </div>
    </footer>
  );
}